@if (showNoData) {
    <div class="no-data">{{ 'controls.testscoreChart.noDataFound' | transloco }}</div>
} @else {
    @if (!loadedChart) {
        <div class="fancy-loader submodule"></div>
    }
}
<div #chart></div>
